<main class="container-fluid">
    <section class="row bg-white shadow mb-3 mt-3 ml-0 mr-0">
        <div class="col-3 border-right p-4 mt-5 mb-5">
            <header class="text-center mb-3">
                Editar campos Capacidad técnica
            </header>

            <form [formGroup]="formCapacidadTecnica" (ngSubmit)="saveSetting()">
                <label class="small text-secondary font-weight-bold mt-2" for="categoria">Categoria</label>
                <select class="form-control form-control-sm" 
                id="categoria" 
                formControlName="categoria">
                    <option value="null" selected="true">
                      Seleccione
                    </option>
                    <option *ngFor="let category of listCategory" value="{{category.categoria_id}}">{{ category.descripcion }}</option> 
                </select>

                <p class="h6 text-dark font-weight-bold mt-4">Tipo de prestador</p>

                <input type="checkbox" class="mr-3" 
                formControlName="muestraComerciante"
                id="muestraComerciante">
                <label class="label label-primary medium" for="muestraComerciante">Se muestra para comerciante</label><br>

                <label class="small text-secondary font-weight-bold mt-2" for="obligatorioComerciante">Obligatorio</label>
                <select class="form-control form-control-sm" 
                id="obligatorioComerciante" 
                formControlName="obligatorioComerciante">
                    <option value="null" selected="true">
                      Seleccione
                    </option>
                    <option value="false">No</option> 
                    <option value="true">Si</option> 
                </select>

                <input type="checkbox" class="mr-3 mt-4" 
                formControlName="muestraNoComerciante"
                id="muestraNoComerciante">
                <label class="label label-primary medium" for="muestraNoComerciante">Se muestra para no comerciante</label><br>

                <label class="small text-secondary font-weight-bold mt-2" for="obligatorioComerciante">Obligatorio</label>
                <select class="form-control form-control-sm" 
                id="obligatorioNoComerciante" 
                formControlName="obligatorioNoComerciante">
                    <option value="null" selected="true">
                      Seleccione
                    </option>
                    <option value="false">No</option> 
                    <option value="true">Si</option> 
                </select>

                <div class="d-flex flex-row mt-4">
                    <button type="reset" class="btn btn-outline-primary border-0 m-auto">Limpiar</button>
                    <button class="btn btn-primary m-auto solicitud-btn-principal" 
                    type="submit"
                    [disabled]="!formCapacidadTecnica.valid">
                        Agregar
                    </button>
                </div>
            </form>
        </div>

        <div  class="col-9 p-4 mt-5 mb-5">
            <div class="d-flex justify-content-between">
                <div>
                    <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
                    <label class="h5">Capacidad Técnica</label>
                </div>
            </div>

            <div class="table-responsive">
                <app-tablas class="table-responsive" 
                [page]="paginaActual" [headers]="headertblCapacidadTecnica"
                [sizeData]="dataTable.paging.totalItems" (paginado)="onPaginado($event)">
                    <tr *ngFor="let item of dataTable.items; let i=index" class="small">
                        <td>{{ item.Descripcion }}</td>
                        <td class="text-center">{{ item.Se_Muestra_Comerciante ? 'Si' : 'No' }}</td>
                        <td class="text-center">{{ item.Obligatorio_Muestra_Comerciante ? 'Si' : 'No' }}</td>
                        <td class="text-center">{{ item.Se_Muestra_No_Comerciante ? 'Si' : 'No'  }}</td>
                        <td class="text-center">{{ item.Obligatorio_Muestra_No_Comerciante ? 'Si' : 'No' }}</td>
                        <td class="text-center">
                            <img src="../../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                            (click)="editarCapacidadTecnica(item)">
                            <img src="../../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                            (click)="deleteCapacidadTecnica(item.Requisitos_Generales_Id)">
                        </td>
                    </tr>
                </app-tablas>
            </div>
        </div>
    </section>
</main>

